import React from 'react'
import Jteam from '../Components/Jteam'
import Navbar from '../Components/Navbar'
import Footer from '../Components/Footer'

const Jointeam = () => {
  return (
    <>
    <Navbar/>
    <Jteam/>
    <Footer/>
    </>
  )
}

export default Jointeam